module.exports = "/lucky-balls/img/infobox/info_Box_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_004.png
// module id = 1069
// module chunks = 0